<template>
    <div class="table-wrapper">
        <table :class="'table ' + (pretty ? 'pretty' : '')">
            <thead>
                <tr>
                    <th v-for="(item, i) in data.header" :key="'org-thead-th-' + i + Math.random()" :class="'with-padding ' + (i === 0 ? 'align-left' : '')">
                        {{item}}
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="(row, i) in data.body" :key="'org-tbody-tr-' + i + Math.random()">
                    <td v-for="(item, r) in row" :key="'org-tbody-tr-td-' + r + Math.random()" :class="'with-padding ' + (r === 0 ? 'align-left' : '')">
                        <span v-if="pretty && item === 1" class="check">&check;</span>
                        <span v-else :class="r > 0 ? 'number' : ''">{{item}}</span>
                    </td>
                </tr>
            </tbody>

            <tfoot>
                <tr v-for="(foot, n) in data.footer" :key="'org-tfoot-tr-' + n + Math.random()">
                    <td v-for="(item, i) in foot" :key="'org-tfoot-td-' + i + Math.random()" :class="'with-padding ' + (i === 0 ? 'align-left' : '')">
                        {{item}}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
export default {
    props: ['data', 'pretty']
};
</script>
